<template>
    <div>
        <buttonlist @help="help" @exps="exps" ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left1" ref="left1">
                <div>
                    <el-tabs :tab-position="'top'" type="">
                        <el-tab-pane :label="$t('getapi[930]')">
                            <div style="background: white;white-space: nowrap;overflow: auto">
                                <el-button type="primary" size="mini" @click.native.prevent="showAddMaterials">{{$t('getapi[878]')}}
                                </el-button>
                                <el-button type="primary" size="mini" @click.native.prevent="batchEdl">{{$t('getapi[7241]')}}</el-button>
                            </div>
                            <el-table :data="dataSetMaterials"
                                      :height="tableHeight  - reduceTableHeight"
                                      header-row-class-name="headerclass"
                                      @selection-change="handleSelectionChange" :row-class-name="tableRowClassName" border size="mini"
                                      style="width: 100%; margin-top:0px"
                                      :header-cell-style="$limits.headerClass"
                                      ref="singleTable">
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="exclusively_id" label="ID"
                                                 v-if="false"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[113]')"></el-table-column>
                                <el-table-column fixed="right" :label="$t('getapi[6048]')">
                                    <template slot-scope="scope">
                                        <el-popconfirm
                                                :confirmButtonText="$t('getapi[937]')"
                                                :cancelButtonText="$t('getapi[6]')"
                                                icon="el-icon-info"
                                                iconColor="red"
                                                :title="$t('getapi[637]')"
                                                @onConfirm="delMaterials(scope.$index)"
                                        >
                                            <el-button slot="reference" type="text" size="mini">{{ $t('getapi[3889]')
                                                }}
                                            </el-button>
                                        </el-popconfirm>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                
            </li>
            <!-- <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid1" ref="mid1">
                <div>
                    
                </div>
            </li> -->
        </ul>
        <!-- 新增物料弹框 -->
        <selector :isVisible="addmaterialsvisible" :selectType="16" :isBatch=true :isSplitPage=true
                  :postUrl="'/LogCustmos/GetPartPopuDataList'" @callback="addmaterials" ref="addmaterials"></selector>
        
        <selector :isVisible="isShowItem" :selectType="0" :isBatch=false :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetEngItemDataList'" @callback="getproject" ref="input"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'importcustoms',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight-180,
                    maxHeight: this.$windowSize.tableHeight-180,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSetMaterials: [], //物料
                dataSetPlanNumber: [], //计划清单
                dataSetDetails1: {
                    ColumnsList: [],
                    DataList: []
                }, //模拟配料
                dataSetDetails2: {
                    ColumnsList: [],
                    DataList: []
                },
                dataSetDetails3: {
                    ColumnsList: [],
                    DataList: []
                },
                loading: false,
                addmaterialsvisible: false, // 新增物料弹窗
                selectIDData: [], // 物料多选ID合集
                selectIDPlanData: [], // 物料多选ID合集
                selectIndex: 0, // 分页
                select1Data: [], // 多选（按采购件新算法）
                select2Data: [], // 多选（按采购件）
                PlanNo: '', // 计划标识
                item_code: '', // 项目编码
                isShowTransfer: false,
                isShowItem: false,
                reduceTableHeight: Common.reduceTableHeight1_1,
                tabNo:"0",
                tableHeader: [],
                tableHeader1: [],
                tableHeader2: [],
                activeName:'1',
                title:"",
                scrollTop:0,
            };
        },
        mounted: function () {
            let that = this;
            that.$nextTick(() => {
                addEventListener('paste', that.keyPaste);//创建键盘粘贴监听事件
            });
            that.$limits.dragControllerDiv1();
            that.authority();
            that.colsort();
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })

        },
        beforeDestroy() {
            let that = this
            removeEventListener('paste', that.keyPaste);
        },
        methods: {            
            // 修改表格顺序
            opentable(){
                // console.log("测试:"+this.tabNo);
                this.$refs.ctab.clearInputs(true);
            },
            colsort(){
                let that = this;
                that.$loadviewfields.Fileds('FrmSimulation',that.tabNo,PFileds=>{
                    if(that.tabNo==0){
                        that.tableHeader=PFileds;		
                    }
                    else if(that.tabNo==1){
                        that.tableHeader1=PFileds;		
                    }
                    else if(that.tabNo==2){
                        that.tableHeader2=PFileds;		
                    }
                });
            },
            sortclick(val){                
                let that = this;
                if(val==1){
                    this.colsort();
                }
            },
            selpage(){
                let that = this;
                that.selectIndex=that.activeName;
                if(that.activeName==1){
                    that.tabNo="0";
                    that.title=that.$t('getapi[8706]')//"模拟配料(新算法)";
                }
                else if(that.activeName==2){
                     that.tabNo="1";
                     that.title=that.$t('getapi[8707]')//"模拟配料(按采购件)";
                }
                else if(that.activeName==3){
                     that.tabNo="2";
                     that.title=that.$t('getapi[8708]')//"模拟配料(按料表)";
                }else{
                    that.tabNo="0";
                    that.title=that.$t('getapi[100]')//"模拟配料";
                }
                that.$nextTick(function () {
                    that.$processdata.initForm(that.activeName)
                })
                // that.sortclick();
                that.colsort();
                // that.opentable();
            },
            tableRowClassName({row, rowIndex}){
                row.index = rowIndex;
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12968]"),this.$t("getapi[6577]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('export');
            },
            leftt(e) {
                var left = document.getElementsByClassName('left1');
                var mid = document.getElementsByClassName('mid1');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            // 添加物料
            showAddMaterials() {
                let that = this;
                that.addmaterialsvisible = true;
                that.$refs.addmaterials.clearInput(that.addmaterialsvisible, true, 4);
            },
            addmaterials(data) {
                let that = this;
                for (let i = 0; i < data.length; i++) {
                    that.dataSetMaterials = [
                        ...that.dataSetMaterials,
                        {
                            part_code: data[i].part_code,
                            part_version: data[i].part_version,
                            exclusively_id: data[i].exclusively_id,
                        }
                    ];
                }
            },
            // 批量选择
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData.push(val[i].exclusively_id);
                }
            },
            // 计划单号清单批量选择
            handleSelectionPlanChange(val) {
                let that = this;
                that.selectIDPlanData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectIDPlanData.push(val[i].$index);
                }
            },
            // 批量删除
            batchEdl() {
                let that = this;
                let arr = that.dataSetMaterials.filter(item => {
                    return that.selectIDData.every(item2 => {
                        return item.exclusively_id != item2;
                    });
                });
                that.dataSetMaterials = arr;
            },
            // 计划单号清单批量删除
            batchEdlPlan() {
                let that = this;
                let arr = that.dataSetMaterials.filter(item => {
                    return that.selectIDData.every(item2 => {
                        return item.exclusively_id != item2;
                    });
                });
                that.dataSetMaterials = arr;
            },
            
            // 切换
            selectInfo(val) {                
                let that = this;
                that.loading = true;
                that.selectIndex = val;
                that.activeName = val.toString()
                let partlist = [];
                for (let i = 0; i < that.dataSetMaterials.length; i++) {
                    partlist.push({
                        part_code: that.dataSetMaterials[i].part_code,
                        part_version: that.dataSetMaterials[i].part_version,
                        exclusively_id: that.dataSetMaterials[i].exclusively_id,
                    });
                }
                let parm = {
                    SimulationType: val,
                    partlist: partlist,
                    plannolist: that.dataSetPlanNumber,
                    LangType: that.$processdata.getLang(),
                };
                console.log(JSON.stringify(parm));
                that.$http.urlpost('/Pur/Requisition/GetSimulationList', parm, function (res) {
                    if (res.Success == 1) {
                        if (val == 1) {
                            that.dataSetDetails1 = res.DataContent;
                            that.$nextTick(function () {
                                that.$processdata.initForm(1)
                            })
                        } else if (val == 2) {
                            that.dataSetDetails2 = res.DataContent;
                            that.$nextTick(function () {
                                that.$processdata.initForm(2)
                            })
                        } else if (val == 3) {
                            that.dataSetDetails3 = res.DataContent;
                            that.$nextTick(function () {
                                that.$processdata.initForm(3)
                            })
                        }
                    } else {
                        if (val == 1) {
                            that.dataSetDetails1 = [];
                        } else if (val == 2) {
                            that.dataSetDetails2 = [];
                        } else if (val == 3) {
                            that.dataSetDetails3 = [];
                        }
                    }
                    that.loading = false;
                });

            },
            //导出
            exps() {
                let that = this;
                //that.selectIndex = tab.name;
                that.loading = true;
                let parm = [];
                for (let i = 0; i < that.dataSetMaterials.length; i++) {
                    parm = [
                        ...parm,
                        {
                            exclusively_id: that.dataSetMaterials[i].exclusively_id,
                            part_code: that.dataSetMaterials[i].part_code,
                            part_version: that.dataSetMaterials[i].part_version,
                            LangType: that.$processdata.getLang(),
                        }
                    ];
                }
                that.$http.urlpost('/LogCustmos/ImportCustomsList', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                         window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
            
            //  删除物料
            delMaterials(index) {
                let that = this;
                that.dataSetMaterials.splice(index, 1);
            },
            selectItem_code() {
                let that = this;
                that.isShowItem = true;
                that.$refs.input.clearInput(this.isShowItem);
            },
            getproject(val) {
                let that = this;
                that.item_code = val.item_name;
            },
            // 粘贴
            keyPaste(e) {
                let that = this;
                if(this.$route.name == this.$options.name){
                    if (e.clipboardData) {
                        var data = e.clipboardData.getData('Text');
                        if (!that.$limits.fnIsEmpty(data)) {
                            that.check(data);
                        }
                    }
                }
            },
            check(datap) {
                let that = this
                console.log(JSON.stringify(datap))
                let str = JSON.stringify(datap)
                str = str.replace('"', '').replace('"', '')
                let arr = str.split("\\r\\n")
                console.log('arr' + arr)
                let arrlist = []
                for (let i = 0; i < arr.length - 1; i++) {
                    if (arr[i].split('\\t').length == 2) {
                        arrlist = [...arrlist, {
                            part_code: arr[i].split('\\t')[0],
                            part_version: arr[i].split('\\t')[1],
                            exclusively_id: '',
                        }]
                    } else {
                        that.dataSetMaterials = [...that.dataSetMaterials, {
                            part_code: arr[i].split('\\t')[0],
                            part_version: arr[i].split('\\t')[2],
                            exclusively_id: '',
                        }]
                    }
                }
                if (arrlist.length > 0) {
                    let parm = {
                        list: arrlist
                    }
                    that.$http.urlpost('/LogCustmos/GetPartInfoPasteByPartCode', parm, function (res) {
                        if (res.Success == 1) {
                            let data = res.DataContent.List
                            for (let i = 0; i < data.length; i++) {
                                that.dataSetMaterials = [...that.dataSetMaterials, {
                                    part_code: data[i].part_code,
                                    part_version: data[i].part_version,
                                    exclusively_id: data[i].exclusively_id
                                }]
                            }
                        }
                    });
                }
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
